// import firebaseService from 'firebaseService'

const db = {} //firebaseService.db.collection('products')

const api = {
  getAll: () => db, //.get(),
  getById: id => db, //.doc(id).get(),
  addById: (id, data) => db, //.doc(id).set(data),
  removeById: id => db, //.doc(id).delete(),
}

export default api



// WEBPACK FOOTER //
// ./src/api.js